// lazy-pages.tsx
import { lazy } from 'react';

export const OrderPage = lazy(() =>
  import('@css-xp/ppc-cart-page').then((module) => ({
    default: module.OrderPage,
  }))
);

export const EntitlementPage = lazy(() =>
  import('@css-xp/ppc-entitlement-page').then((module) => ({
    default: module.EntitlementPage,
  }))
);

const loadQuotesPageModule = () => import('@css-xp/ppc-quotes-page');

export const QuotesPage = lazy(() =>
  loadQuotesPageModule().then((module) => ({
    default: module.QuotesPage,
  }))
);

export const QuoteDetailPage = lazy(() =>
  loadQuotesPageModule().then((module) => ({
    default: module.QuoteDetailPage,
  }))
);

export const CartPage = lazy(() =>
  import('@css-xp/ppc-cart-page').then((module) => ({
    default: module.CartPage,
  }))
);
